import React, { useState, useEffect } from 'react';

const DISMISS_DEMO_BANNER_KEY = 'dismiss_demo_banner';

const DemoBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const isDemo = sessionStorage.getItem('is_demo_login') === 'true';
    const isDismissed = localStorage.getItem(DISMISS_DEMO_BANNER_KEY) === 'true';
    
    if (isDemo && !isDismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem(DISMISS_DEMO_BANNER_KEY, 'true');
  };

  if (!isVisible) return null;

  return (
    <div className="p-4 mb-2 rounded-lg relative border border-warning bg-light text-dark">
      <button
        onClick={handleDismiss}
        className="absolute top-2 right-2 text-grey_dark hover:opacity-70 transition-opacity"
        aria-label="Dismiss"
      >
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center bg-yellow-200">
          <svg className="w-4 h-4 text-warning" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div className="flex-1">
          <h4 className="text-sm font-semibold text-dark">Demo Account</h4>
          <p className="text-xs mt-1 leading-relaxed text-dark_b">
            This is a demo account where you can test the app's features. Please be aware that any data entered here is public.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DemoBanner;
